import React from 'react';

export function safeJsonParse(data) {
  let ret;
  try {
    ret = JSON.parse(data);
  } catch (err) {
    console.warn(err.message);
  }
  return ret;
}

export function safeJsonStringify(data) {
  let ret = '';
  try {
    ret = JSON.stringify(data);
  } catch (err) {
    console.warn(err.message);
  }
  return ret;
}

export function convertContentfulInlineLink(node, children) {
  if (node.data.uri.indexOf('avenuebank.com.au') > 0
        || node.data.uri.indexOf('localhost') > 0
        || node.data.uri.startsWith('#')) {
    return (
      <a
        className="underline"
        href={node.data.uri}
      >{children}
      </a>
    );
  }

  return (
    <a
      className="underline"
      href={node.data.uri}
      target="_blank"
      rel="noreferrer"
    >{children}
    </a>
  );
}
